// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2SR9e","left":"InfoRow_left__1ChPM"};